import type { CaseDefinition } from "../../domain/types/index.js";
import { attackTraits } from "./describeAttacks.js";
import { StatIcon } from "../../components/StatIcon.js";
import { ZoneIcon } from "../../components/ZoneIcon.js";

function TraitIcon({ id }: { id: ReturnType<typeof attackTraits>[number]["id"] }) {
  if (id === "fatigue") return <StatIcon name="fatigue" />;
  if (id === "rollback") return <StatIcon name="progress" />;
  if (id === "action") return <StatIcon name="action" />;
  return <ZoneIcon name={id === "hand" ? "hand" : "deck"} />;
}

export function AttackProfile({ spec }: { spec: CaseDefinition }) {
  const traits = attackTraits(spec);
  return <section className="attack-profile" aria-label="起きるハプニング">
    <h3>起きるハプニング</h3>
    <ul className="attack-traits">
      {traits.map(trait => <li key={trait.id} data-trait={trait.id}>
        <span className="attack-trait-icon"><TraitIcon id={trait.id} /></span>
        <strong>{trait.label}</strong>
      </li>)}
    </ul>
  </section>;
}
